import EventEmitter from "./_EventEmitter";

export default class BreakPoints extends EventEmitter{

	constructor(el) {
		super(el);
    this.mediaQueries = [
      { name: 'xxs', value: '(min-width: 0px) and (max-width:575px)'},
      { name: 'xs', value: '(min-width: 576px) and (max-width:767px)'},
      { name: 'sm', value: '(min-width: 768px) and (max-width:1023px)'},
      { name: 'md', value: '(min-width: 1024px) and (max-width:1439px)'},
      { name: 'lg', value: '(min-width: 1440px)'}
    ]
		this.setBreakpoints();
	}

	setBreakpoints() {
    this.mediaQueryList = [];

    this.changeHandler = this.bqChecker.bind(this);
    this.resizeHandler = this.bqChecker.bind(this);

    this.mediaQueries.forEach((mq, i) => {
      this.mediaQueryList.push(
        window.matchMedia(mq.value)
      )
      const currentQueryList = this.mediaQueryList[i];

      //on change
      currentQueryList.addEventListener('change', (e) => {
        this.changeHandler(e, mq, currentQueryList)
      });
    })

    //on init
    this.mediaQueries.forEach((mq, i) => {
      this.changeHandler(undefined, mq, this.mediaQueryList[i])
    })

    //on resize
    window.addEventListener('resize', (e) => {
      this.mediaQueries.forEach((mq, i) => {
        this.changeHandler(e, mq, this.mediaQueryList[i])
      })
    })
	}

  bqChecker(e, mq, queryList) {
    if (queryList.matches === true) {
      this.currentMq = mq;
      this.trigger("change", [{e, mq, queryList}]);
    }
  }
}
